import codeTypeApi from '@/api/code-type.api';
import { defineStore } from 'pinia';

export const useCodeTypeStore = defineStore('codeType', {
  state: () => ({
    data: []
  }),
  getters: {
    codeType: (state) => (groepnaam, code) =>
      state.data[groepnaam] ? state.data[groepnaam][code] : undefined
  },
  actions: {
    async preLoadGroepnamen(groepnamen) {
      return groepnamen.forEach(async (groepnaam) => {
        if (!this.data[groepnaam]) {
          await this.loadGroepnaam(groepnaam);
        }
      });
    },
    async loadGroepnaam(groepnaam) {
      if (this.data[groepnaam]) {
        return;
      }

      return codeTypeApi.getCodeType(groepnaam).then((data) => {
        this.addCodeType(groepnaam, data);
      });
    },
    async getCodeTypeKorteText(groepnaam, code) {
      let codeType = this.codeType(groepnaam, code);
      if (!codeType) {
        await this.loadGroepnaam(groepnaam);
        codeType = this.codeType(groepnaam, code);
      }

      if (!codeType) {
        return `${groepnaam} not found`;
      }
      return codeType.korteTekst;
    },
    addCodeType(groepnaam, codeTypes) {
      this.data = {
        ...this.data,
        ...{
          [groepnaam]: codeTypes
            .map((codeType) => ({ [codeType.code]: codeType }))
            .reduce((prev, current) => ({ ...prev, ...current }), {})
        }
      };
    }
  }
});
